export const Rectangle15 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="96"
    height="45"
    viewBox="0 0 96 45"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_637_68994)">
      <path
        d="M4.26123 27.2911L66.2778 3.69897L90.5711 12.0397C91.4334 12.3357 91.4822 13.5369 90.6467 13.9018L32.3945 39.3483C32.1381 39.4603 31.8465 39.4598 31.5906 39.3469L4.26123 27.2911Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_637_68994"
        x="0.26123"
        y="0.698975"
        width="94.9854"
        height="43.7329"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_637_68994"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_637_68994"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const Rectangle14 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="107"
    height="47"
    viewBox="0 0 107 47"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_637_68993)">
      <path
        d="M90.7646 25.8542L26.7313 3.57275L1.00993 16.9454C0.239059 17.3461 0.310822 18.4716 1.12636 18.7713L61.6055 40.9912C61.8726 41.0893 62.1689 41.069 62.4201 40.9354L90.7646 25.8542Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_637_68993"
        x="0.471191"
        y="0.572754"
        width="106.293"
        height="45.4797"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="12" dy="1" />
        <feGaussianBlur stdDeviation="2" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_637_68993"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_637_68993"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export const Rectangle13 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="82"
    height="39"
    viewBox="0 0 82 39"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M81.4249 19.6576C81.8888 19.102 81.627 18.2528 80.9307 18.0549L19.9689 0.728697C19.611 0.626977 19.2262 0.732372 18.9701 1.00227L0.731293 20.2233L65.2688 39.0097L81.4249 19.6576Z"
      fill="currentColor"
    />
  </svg>
);

export const Rectangle12 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="84"
    height="41"
    viewBox="0 0 84 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.731453 18.9503C0.197379 18.4034 0.449525 17.4838 1.18786 17.2857L62.5106 0.838751C62.8551 0.746344 63.2228 0.844466 63.4755 1.09626L83.2355 20.7865L21.7232 40.4466L0.731453 18.9503Z"
      fill="currentColor"
    />
  </svg>
);

export const Rectangle11 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="65"
    height="43"
    viewBox="0 0 65 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.235352 42.6018L64.2687 19.0097L0.235352 0.223343V42.6018Z"
      fill="url(#paint0_linear_637_68982)"
    />
    <path
      d="M0.235352 42.6018L64.2687 19.0097L0.235352 0.223343V42.6018Z"
      fill="url(#paint1_linear_637_68982)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_637_68982"
        x1="31.9999"
        y1="0.223343"
        x2="31.9999"
        y2="41.728"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D9D9D9" />
        <stop offset="1" stopColor="#737373" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_637_68982"
        x1="47.6301"
        y1="15.5145"
        x2="11.2502"
        y2="47.651"
        gradientUnits="userSpaceOnUse"
      >
        <stop className="rectangle-11-stop1" />
        <stop offset="1" className="rectangle-11-stop2" />
        <style>{`
.rectangle-11-stop1 {
stop-color: #5C84D2;
transition: stop-color 300ms ease-in-out;
}
.rectangle-11-stop2 {
stop-color: #4B67A1;
transition: stop-color 300ms ease-in-out;
}
.group:hover .rectangle-11-stop1 {
stop-color: #4F78CB;
}
.group:hover .rectangle-11-stop2 {
stop-color: #445F95;
}
`}</style>
      </linearGradient>
    </defs>
  </svg>
);

export const Rectangle10 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="64"
    height="43"
    viewBox="0 0 64 43"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M63.2354 0.786377L0.210407 20.4465L63.2354 42.2911V0.786377Z"
      fill="url(#paint0_linear_637_68981)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_637_68981"
        x1="31.7229"
        y1="0.786377"
        x2="31.7229"
        y2="42.2911"
        gradientUnits="userSpaceOnUse"
      >
        <stop className="rectangle-10-stop1" />
        <stop offset="1" className="rectangle-10-stop2" />
      </linearGradient>
    </defs>
  </svg>
);

export const Rectangle9 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="61"
    height="100"
    viewBox="0 0 61 100"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M60.7637 0.572754L0.25972 22.8542V99.3102L60.235 67.2628C60.5604 67.0889 60.7637 66.7498 60.7637 66.3808V0.572754Z"
      fill="currentColor"
    />
  </svg>
);
export const Rectangle8 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="67"
    height="99"
    viewBox="0 0 67 99"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M0.713867 0.883545L66.2598 22.2912V98.3103L1.89833 69.5676C1.17783 69.2458 0.713867 68.5305 0.713867 67.7414V0.883545Z"
      fill="currentColor"
    />
  </svg>
);

export const Glow = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="365"
    height="338"
    viewBox="0 0 365 338"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_f_637_68877)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M158.947 121.137C178.622 117.888 197.803 126.439 213.928 138.194C228.242 148.629 235.094 164.748 241.459 181.288C248.981 200.835 264.02 222.566 253.318 240.556C242.631 258.52 216.397 255.53 195.682 258.235C178.871 260.43 162.581 260.91 146.898 254.451C128.212 246.756 108.145 237.785 100.532 219.049C92.2501 198.665 95.5796 174.761 106.846 155.876C117.969 137.233 137.54 124.672 158.947 121.137Z"
        fill="#4B67A1"
        fillOpacity="0.45"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_637_68877"
        x="-109.981"
        y="-85.4583"
        width="572.919"
        height="551.07"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="102.95"
          result="effect1_foregroundBlur_637_68877"
        />
      </filter>
    </defs>
  </svg>
);

export const Star = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="5"
    height="6"
    viewBox="0 0 5 6"
    fill="none"
    className="rotate-[32deg] will-change-transform"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    style={{ backfaceVisibility: 'hidden' }}
  >
    <path
      d="M0.835616 0.404317L1.34047 1.11384C1.94056 1.95719 3.01817 2.2575 3.98859 1.8518L4.22426 1.75327L4.02743 1.92444C3.21691 2.62927 2.91889 3.78737 3.29509 4.77033L3.61159 5.59731L3.10673 4.88778C2.50665 4.04443 1.42903 3.74413 0.458608 4.14983L0.222945 4.24835L0.419776 4.07719C1.23029 3.37235 1.52831 2.21426 1.15211 1.2313L0.835616 0.404317Z"
      fill="#BBBAFA"
    />
  </svg>
);

export const Glow2 = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="274"
    height="265"
    viewBox="0 0 274 265"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className="will-change-transform"
    style={{ backfaceVisibility: 'hidden' }}
  >
    <g filter="url(#filter0_f_735_34454)">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M140.466 92.3648C150.06 93.3155 157.947 99.7487 164.006 107.303C169.385 114.009 170.568 122.446 171.47 131.02C172.537 141.152 176.841 153.257 169.592 160.363C162.354 167.459 150.478 162.751 140.466 161.414C132.341 160.329 124.674 158.503 118.159 153.494C110.396 147.525 102.147 140.782 100.937 131.02C99.6199 120.398 104.166 109.584 111.79 102.129C119.316 94.769 130.027 91.3305 140.466 92.3648Z"
        fill="#8989FF"
        fillOpacity="0.56"
      />
    </g>
    <defs>
      <filter
        id="filter0_f_735_34454"
        x="0.710938"
        y="-7.81543"
        width="273"
        height="272"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feGaussianBlur
          stdDeviation="50"
          result="effect1_foregroundBlur_735_34454"
        />
      </filter>
    </defs>
  </svg>
);
